import React from 'react';

import {
  MonetizationOn as MonetizationIcon,
  Notifications as NotificationsIcon,
  Password as PasswordIcon,
  Person as PersonIcon,
  Phonelink as PhonelinkIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';

import { appRoutes } from '@clearverify/constants';

import { DEFAULT_AVATAR } from 'src/assets';
import type { MenuItem } from 'src/components/common';
import { ItemDetailsLayout } from 'src/components/common';
import { useCurrentUser, useUserAvatar } from 'src/hooks/user';
import { getUserFullName } from 'src/utils/user';

export const AccountLayoutClearVerifyAdmin: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { id: userId, user } = useCurrentUser();
  const { userAvatar, userAvatarLoading, updateUserAvatar, userAvatarUpdating } =
    useUserAvatar(userId);

  const fullName = getUserFullName(user);
  const title = user?.title;

  return (
    <ItemDetailsLayout
      name={fullName}
      subtitle={title}
      logoUrl={userAvatar?.downloadUrl || DEFAULT_AVATAR}
      menuItems={menuItems}
      logoProps={{
        onChange: updateUserAvatar,
        loading: userAvatarLoading || userAvatarUpdating,
      }}
    >
      <Box>{children}</Box>
    </ItemDetailsLayout>
  );
};

const menuItems: Array<MenuItem> = [
  {
    link: appRoutes.account.personalInformation,
    title: 'Personal Information',
    icon: PersonIcon,
  },
  {
    link: appRoutes.account.generalBillingRules,
    title: 'General Billing Rules',
    icon: MonetizationIcon,
  },
  {
    link: appRoutes.account.billingSettings,
    title: 'Initial Billing Rules',
    icon: MonetizationIcon,
  },
  {
    link: appRoutes.account.notifications,
    title: 'Notifications',
    icon: NotificationsIcon,
    divider: true,
  },
  {
    link: appRoutes.account.security,
    title: 'Sign-in & Security',
    icon: PasswordIcon,
  },
  {
    link: appRoutes.account.setupMfa,
    title: 'Multi-factor Authentication',
    icon: PhonelinkIcon,
  },
];
